import { Capacitor } from "@capacitor/core"
import { SecureStorage, KeychainAccess } from "@aparajita/capacitor-secure-storage"
import Storage from "@/utils/storage"
import { createTokenStore } from "@/utils/token-store"

// isPluginAvailable is true from the JS registration alone, so an older binary without the native plugin needs the header check
const hasSecureStorage = (Capacitor.PluginHeaders || []).some(
  (header) => header.name === "SecureStorage"
)

// afterFirstUnlock lets a push-triggered launch on a locked iPhone still read the token
if (hasSecureStorage) SecureStorage.setDefaultKeychainAccess(KeychainAccess.afterFirstUnlock)

export default createTokenStore({
  secure: hasSecureStorage ? SecureStorage : null,
  legacy: Storage,
})
